import { observer } from 'mobx-react';
import { FC } from 'react';
import { BaseCandidate, BaseCandidateFieldConfig, Candidate } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';

interface Props extends RowProps {
    onClickRow: (candidateId: BaseCandidate['id']) => void;
    rowFields: BaseCandidateFieldConfig[];
}

const Row: FC<Props> = (props) => {
    const rowStyle = `${props.baseStyle} border-b border-[#ddd] cursor-pointer`;
    const centerRowStyle = `${rowStyle} text-center`;
    const iconCheck = <img src="/elements/icons/check.svg" alt="Ja" className="inline-block" />;
    const iconCross = <img src="/elements/icons/cross.svg" alt="Nei" className="inline-block" />;

    const renderCell = (value: string | boolean, name: string, id: string, index: number, candidate: Candidate) => {
        let displayValue;

        if (id === 'picture') {
            displayValue = value === '' ? iconCross : iconCheck;
        } else if (id === 'occupation') {
            displayValue = candidate.occupation;
        } else if (id === 'city') {
            displayValue = candidate.city;
        } else if (id === 'pre_cumulated') {
            displayValue = value === 'true' ? iconCheck : null;
        } else {
            displayValue = typeof value === 'boolean' ? (value ? iconCheck : iconCross) : value;
        }

        return (
            <td key={`${id}-${index}`} className={id === 'pre_cumulated' ? centerRowStyle : rowStyle}>
                {displayValue}
            </td>
        );
    };

    return (
        <tbody>
            {props.candidates.map((candidate) => (
                <tr key={candidate.id} className="hover:bg-[#e3e3e3]" onClick={() => props.onClickRow(candidate.id)}>
                    {props.rowFields.map((column, index) => {
                        const value = candidate[column.key as keyof BaseCandidate];
                        return renderCell(value, column.name, column.id, index, candidate);
                    })}
                </tr>
            ))}
        </tbody>
    );
};

interface RowProps {
    baseStyle: string;
    candidates: Candidate[];
}

const RowWithStore = (props: RowProps) => {
    const { candidateStore } = getStore();

    return (
        <Row
            candidates={props.candidates}
            baseStyle={props.baseStyle}
            onClickRow={candidateStore.onSelectCandidate}
            rowFields={candidateStore.getCandidateRowFields()}
        />
    );
};

export default observer(RowWithStore);
